import React, { useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Select } from 'grommet';

import { getEnterpriseList, getEnterpriseFile } from '../../../../api';
import { PageWrapper, MigrationActions, Breadcrumbs, Pagination } from '../../../../components';
import { TableHeader, TableMessages, TableWrap, TableRow, TableCols, TableActionsCol } from '../../../../components/listing';

import { useOpenLayer, useFetchListing } from '../../../../hooks';

import { layers, pagination, messageDictionary, enterpriseStatus, enterpriseType } from '../../../../constants';

const SearchResult = () => {
  const { migrationId } = useParams();
  const [searchTerm, setSearchTerm] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  const { open } = useOpenLayer();

  const filters = useMemo(() => ({
    ...(searchTerm && { search: searchTerm }),
    ...(typeFilter && { type_id: typeFilter }),
    ...(statusFilter && { status_id: statusFilter })
  }), [searchTerm, typeFilter, statusFilter]);

  const {
    loading,
    list,
    requestError,
    page,

    onNavigate,
  } = useFetchListing({
    migrationId,
    get: getEnterpriseList,
    filters
  });

  return (
    <PageWrapper>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        width: '100%'
      }}>
        <MigrationActions />
        <Breadcrumbs />
      </div>

      <TableWrap>
        <TableHeader
          title='Empreendimentos'
          totalItens={list.total}

          download={{
            fileName: 'empreendimentos.csv',
            resource: getEnterpriseFile,
          }}
        />

        <div className='table-filter'>
          <input
            type='search'
            placeholder='Buscar por nome...'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className='table-filter__input'
          />

          <Select
            options={[{ name: 'Todos os tipos', id: '' }, ...enterpriseType]}
            value={typeFilter?.toString() ?? ''}
            labelKey='name'
            valueKey={{
              key: 'id',
              reduce: true,
            }}
            emptySearchMessage='Selecione um tipo'
            onChange={({ target }) => setTypeFilter(target.value)}
            className='table-filter__select'
          />

          <Select
            options={[{ name: 'Todos os status', id: '' }, ...enterpriseStatus]}
            value={statusFilter?.toString() ?? ''}
            labelKey='name'
            valueKey={{
              key: 'id',
              reduce: true,
            }}
            emptySearchMessage='Selecione um status'
            onChange={({ target }) => setStatusFilter(target.value)}
            className='table-filter__select'
          />
        </div>

        {requestError && (
          <TableMessages message={messageDictionary.requestFail} />
        )}

        {loading && !requestError && (
          <TableMessages message={messageDictionary.waitingResponseRequest} />
        )}

        {!loading && !requestError && list.total <= 0 && (<TableMessages />)}

        {!loading && !requestError && list.data.map((row, index) => (
          <TableRow key={index}>
            <TableCols
              columns={[
                { width: 'medium', value: row.name },
                { width: 'small', value: row.location_city },
                { width: 'small', value: row.location_state_abbreviation },
              ]}
            />

            <TableActionsCol
              actions={[
                {
                  label: 'detalhes',
                  action: () => open({ entityIdentifier: row._id, layer: layers.detail }),
                }
              ]}
            />
          </TableRow>
        ))}
      </TableWrap>

      <Pagination
        totalOfRows={list.total}
        page={page}
        perPage={pagination.limit}
        onNavigate={onNavigate}
      />
    </PageWrapper>
  )
}

export default SearchResult;
